import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { useWorkspaceContext } from "../../state/workspaceContext";
import { uploadDocument } from "../../lib/financialDocument";
import { toBase64 } from "../../helpers/file";
import { ImporterContext } from "./importer.context";

interface MutationParams {
    file: File;
    documentId: string;
}

export function useImporterUploadMutation() {
    const { updateDocumentRow, importerQueue, reconciledFinancialAccount } =
        useContext(ImporterContext);
    const { activeWorkspaceId } = useWorkspaceContext();

    return useMutation({
        mutationFn: async ({ file }: MutationParams) => {
            if (!activeWorkspaceId) {
                throw new Error("No active workspace");
            }

            return await uploadDocument({
                workspaceId: activeWorkspaceId,
                file: await toBase64(file),
                filename: file.name,
                contentType: file.type,
                importerQueue: !reconciledFinancialAccount
                    ? importerQueue
                    : undefined,
                reconciledFinancialAccountId: reconciledFinancialAccount?.id,
            });
        },
        onSuccess: ([financialDocument], { documentId }) => {
            if (!financialDocument.integrationAccount) {
                throw new Error("Integration account not created for document");
            }

            updateDocumentRow(documentId, {
                financialDocument,
                integrationAccount: financialDocument.integrationAccount,
            });
        },
    });
}
